import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { bottomNavigation, headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const useUsersStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    const headingHeight = 48;
    const spaceBelowHeading = 34;
    const pageEndPadding = 8;
    const statusHeight = 52.8;
    const spaceAfterStatus = 12;
    const containerEndPadding = 8;
    const spaceBelowTabs = 8;
    const cardContainerHeightDesktop = `${spaceAboveHeader + headerHeight + spaceBelowHeader + headingHeight + spaceBelowHeading + pageEndPadding + statusHeight + spaceAfterStatus + containerEndPadding}px`;
    const cardContainerHeightMobile = `${headerHeight + spaceAboveHeader + headingHeight + spaceBelowTabs + containerEndPadding + bottomNavigation}px`;
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: isMobileIpadNavigation ? 1 : 4.25,
            // px: isMobileIpadNavigation ? 0 : clamp.calculate(8, 32),
            overflow: 'hidden',
            height: '100%'
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            backgroundColor: (theme) => alpha(theme.palette.common.black, 0.2),
            px: clamp.calculate(8, 32),
            height: '100%',
            paddingBottom: 1
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center'
        },
        userContainer: {
            display: 'flex',
            flexDirection: 'column',
            // overflow: 'auto',
            // px: 1,
            zIndex: 1,
            // height: isMobileIpadNavigation
            //   ? `calc(100dvh - ${cardContainerHeightMobile})`
            //   : `calc(100dvh - ${cardContainerHeightDesktop})`,
            gap: '12px'
        },
        addNewUserHeading: {
            color: (theme) => theme.palette.common.white,
            fontWeight: 400
        },
        bottomUserDrawer: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        }
    };
};
export default useUsersStyles;
